<template>
  <div>
    <a-table :columns="columns" :data-source="tableData" :loading="tableLoading" :pagination="pagination"
      class="tableStyle" @change="triggerTableChange">
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px">
        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
          Search
        </a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
          Reset
        </a-button>
      </div>
      <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
        style="padding: 8px;display: flex;flex-direction: column;">
        <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
          <a-select-option value="all">
            All
          </a-select-option>
          <a-select-option value="true">
            Active
          </a-select-option>
          <a-select-option value="false">
            Inactive
          </a-select-option>
        </a-select>
      </div>
      <template slot="action" slot-scope="user">
        <a-dropdown>
          <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <a-icon style="font-size: 25px" type="ellipsis" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="editProfile(user)">Edit User Profile?</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="changePassword(user)">Change Password?</a>
            </a-menu-item>
            <!-- <a-menu-item v-if="user.isActive === true">
                                    <a @click="showDisableModal(user)">
                                         Disable User?
                                    </a>
                                </a-menu-item> -->
            <!-- <a-menu-item v-if="user.isActive === false">
                                    <a @click="showChangePassword(user)"> Enable User?</a>
                                </a-menu-item> -->
          </a-menu>
        </a-dropdown>
      </template>

      <template slot="status" slot-scope="data">
        <status-component :status="data"></status-component>
      </template>
    </a-table>
  </div>
</template>

<script>
import StatusComponent from "@/components/shared-components/StatusComponent.vue";
import moment from "moment";
const columns = [
  {
    title: "Name",
    // width: 150,
    dataIndex: "name",
    key: "name",
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
  {
    title: "Phone Number",
    dataIndex: "phoneNumber",
    // width: 130,
  },
  {
    title: "Email",
    dataIndex: "email",
    //  width: 50,
  },
  {
    title: "Gender",
    dataIndex: "gender",
    key: "gender",
  },
  {
    title: "Status",
    dataIndex: "status",
    // width: 150,
    scopedSlots: {
        customRender: "status",
        filterDropdown: 'filterStatusDropdown',
        filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.status
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
  },
  {
    title: "Date Created",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  components: { StatusComponent },
  name: "UserCustomersTable",
  props: {
    users: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tableLoading: { type: Boolean },
  },
  data: () => ({
    columns,
    tableData: [],
    pagination: {
      pageSize: 20,
    },
    searchText: "",
    searchInput: null,
    searchedColumn: '',
    availableClients: [],
  }),
  computed: {
    warehouseUsers() {
      return this.$store.getters["generic/GetCustomerUsers"];
    },
  },
  methods: {
    triggerTableChange(pagination) {
      this.$emit("tableChange",pagination);
    },
    editProfile(payload) {
      console.log("client user ---", payload);
      this.$emit("triggerEditProfile", payload);
    },
    changePassword(payload) {
      this.$emit("triggerPassChange", payload);
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
    },
    onInventoryChange(value, clearFilters){
        let result = []

        if(value === 'all'){
            result = this.availableClients
        }else {
            value = value === 'true' ? true : false;
            result = this.availableClients.filter(client => client.isActive === value )
        }
        this.tableData = result.map(client => ({
            id: client.id,
            key: client.id,
            name: client.name,
            phoneNumber: client.phoneNumber,
            email: client.email,
            gender: client.gender,
            status: client.isActive,
            createdAt: moment(client.createdAt).format('DD-MM-YYYY'),
            action: client
        }))
        clearFilters();
    },
    setTableData() {
      let finalUserRequestList = [];
      this.availableClients = this.warehouseUsers.data;
      this.warehouseUsers.data.forEach((request) => {
        let userObject = {};
        userObject["key"] = request.id;
        userObject["name"] = request.name;
        userObject["phoneNumber"] = request.phoneNumber;
        (userObject["email"] = request.email),
          (userObject["gender"] = request.gender);
        userObject["status"] = request.isActive;
        userObject["createdAt"] = moment(request.createdAt).format(
          "DD-MMM-YYYY"
        );
        userObject["action"] = request;

        // orderRquestObject['action'] = request

        finalUserRequestList.push(userObject);
      });
      this.tableData = finalUserRequestList;
      // console.log("table data", this.tableData);
    },
  },
  watch: {
    warehouseUsers: function () {
      this.setTableData();
    },
  },
  mounted() {
    this.setTableData();
  },
};
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}

.orderTable >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>